import { useEffect } from 'react';
import { usePipPlayerStore } from '@/stores/pip-player.store';

export function usePipEscapeClose() {
    const close = usePipPlayerStore((s) => s.close);
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') close();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [close]);
}
